export const contries = [
    {
        value: 'US',
        text: 'United States',
    },
];

export const provinces = JSON.parse(`
[{"text":"Alabama","value":"Alabama","country":"United States"},{"text":"Alaska","value":"Alaska","country":"United States"},{"text":"Albany","value":"Albany","country":"United States"},{"text":"Annapolis","value":"Annapolis","country":"United States"},{"text":"Arizona","value":"Arizona","country":"United States"},{"text":"Arkansas","value":"Arkansas","country":"United States"},{"text":"Atlanta","value":"Atlanta","country":"United States"},{"text":"Augusta","value":"Augusta","country":"United States"},{"text":"Austin","value":"Austin","country":"United States"},{"text":"Baton Rouge","value":"Baton Rouge","country":"United States"},{"text":"Bismarck","value":"Bismarck","country":"United States"},{"text":"Boise","value":"Boise","country":"United States"},{"text":"Boston","value":"Boston","country":"United States"},{"text":"California","value":"California","country":"United States"},{"text":"Carson City","value":"Carson City","country":"United States"},{"text":"Charleston","value":"Charleston","country":"United States"},{"text":"Cheyenne","value":"Cheyenne","country":"United States"},{"text":"Colorado","value":"Colorado","country":"United States"},{"text":"Columbia","value":"Columbia","country":"United States"},{"text":"Columbus","value":"Columbus","country":"United States"},{"text":"Concord","value":"Concord","country":"United States"},{"text":"Connecticut","value":"Connecticut","country":"United States"},{"text":"Delaware","value":"Delaware","country":"United States"},{"text":"Denver","value":"Denver","country":"United States"},{"text":"Des Moines","value":"Des Moines","country":"United States"},{"text":"Dover","value":"Dover","country":"United States"},{"text":"Florida","value":"Florida","country":"United States"},{"text":"Frankfort","value":"Frankfort","country":"United States"},{"text":"Georgia","value":"Georgia","country":"United States"},{"text":"Harrisburg","value":"Harrisburg","country":"United States"},{"text":"Hartford","value":"Hartford","country":"United States"},{"text":"Hawaii","value":"Hawaii","country":"United States"},{"text":"Helena","value":"Helena","country":"United States"},{"text":"Honolulu","value":"Honolulu","country":"United States"},{"text":"Idaho","value":"Idaho","country":"United States"},{"text":"Illinois","value":"Illinois","country":"United States"},{"text":"Indiana","value":"Indiana","country":"United States"},{"text":"Indianapolis","value":"Indianapolis","country":"United States"},{"text":"Iowa","value":"Iowa","country":"United States"},{"text":"Jackson","value":"Jackson","country":"United States"},{"text":"Jefferson City","value":"Jefferson City","country":"United States"},{"text":"Juneau","value":"Juneau","country":"United States"},{"text":"Kansas","value":"Kansas","country":"United States"},{"text":"Kentucky","value":"Kentucky","country":"United States"},{"text":"Lansing","value":"Lansing","country":"United States"},{"text":"Lincoln","value":"Lincoln","country":"United States"},{"text":"Little rock","value":"Little rock","country":"United States"},{"text":"Louisiana","value":"Louisiana","country":"United States"},{"text":"Madison","value":"Madison","country":"United States"},{"text":"Maine","value":"Maine","country":"United States"},{"text":"Maryland","value":"Maryland","country":"United States"},{"text":"Massachusetts","value":"Massachusetts","country":"United States"},{"text":"Michigan","value":"Michigan","country":"United States"},{"text":"Minnesota","value":"Minnesota","country":"United States"},{"text":"Mississippi","value":"Mississippi","country":"United States"},{"text":"Missouri","value":"Missouri","country":"United States"},{"text":"Montana","value":"Montana","country":"United States"},{"text":"Montgomery","value":"Montgomery","country":"United States"},{"text":"Montpelier","value":"Montpelier","country":"United States"},{"text":"Nashville","value":"Nashville","country":"United States"},{"text":"Nebraska","value":"Nebraska","country":"United States"},{"text":"Nevada","value":"Nevada","country":"United States"},{"text":"New Hampshire","value":"New Hampshire","country":"United States"},{"text":"New Jersey","value":"New Jersey","country":"United States"},{"text":"New Mexico","value":"New Mexico","country":"United States"},{"text":"New York","value":"New York","country":"United States"},{"text":"North Carolina","value":"North Carolina","country":"United States"},{"text":"North Dakota","value":"North Dakota","country":"United States"},{"text":"Ohio","value":"Ohio","country":"United States"},{"text":"Oklahoma","value":"Oklahoma","country":"United States"},{"text":"Oklahoma City","value":"Oklahoma City","country":"United States"},{"text":"Olympia","value":"Olympia","country":"United States"},{"text":"Oregon","value":"Oregon","country":"United States"},{"text":"Pennsylvania","value":"Pennsylvania","country":"United States"},{"text":"Phoenix","value":"Phoenix","country":"United States"},{"text":"Pierre","value":"Pierre","country":"United States"},{"text":"Providence","value":"Providence","country":"United States"},{"text":"Raleigh","value":"Raleigh","country":"United States"},{"text":"Rhode Island","value":"Rhode Island","country":"United States"},{"text":"Richmond","value":"Richmond","country":"United States"},{"text":"Sacramento","value":"Sacramento","country":"United States"},{"text":"Salem","value":"Salem","country":"United States"},{"text":"Salt Lake City","value":"Salt Lake City","country":"United States"},{"text":"Santa Fe","value":"Santa Fe","country":"United States"},{"text":"South Carolina","value":"South Carolina","country":"United States"},{"text":"South Dakota","value":"South Dakota","country":"United States"},{"text":"Springfield","value":"Springfield","country":"United States"},{"text":"St。Paul","value":"St。Paul","country":"United States"},{"text":"Tallahassee","value":"Tallahassee","country":"United States"},{"text":"Tennessee","value":"Tennessee","country":"United States"},{"text":"Texas","value":"Texas","country":"United States"},{"text":"Topeka","value":"Topeka","country":"United States"},{"text":"Trenton","value":"Trenton","country":"United States"},{"text":"Utah","value":"Utah","country":"United States"},{"text":"Vermont","value":"Vermont","country":"United States"},{"text":"Virginia","value":"Virginia","country":"United States"},{"text":"Washington","value":"Washington","country":"United States"},{"text":"West Virginia","value":"West Virginia","country":"United States"},{"text":"Wisconsin","value":"Wisconsin","country":"United States"},{"text":"Wyoming","value":"Wyoming","country":"United States"}]
`);

export const globalConstants = {
    UNKOWN: 'Unknown',
    EXPORT_TO_CSV: 'Export To CSV',
    UNAUTHORIZED:
        'You are unauthorized to view this page, please click ok to go to your dashboard',
    MENUS: [
        {
            name: 'Monitoring',
            type: 'group',
            key: 'group_monitoring_t',
            postion: 'top',
        },
        {
            name: 'Dashboard',
            icon: 'fa fa-tachometer',
            path: '/',
            key: 'dashboard',
        },
        {
            name: 'Alerts',
            icon: 'fa fa-flag',
            path: '/alerts',
            key: 'alert',
        },
        {
            name: 'Performance',
            icon: 'fa fa-bar-chart-o',
            path: '/performance',
            key: 'performance',
        },
        {
            name: 'Location View',
            icon: 'fa fa-map-o',
            key: 'location_view',
            path: '/location-view',
        },
        {
            name: 'Monitoring',
            type: 'group',
            key: 'group_monitoring_b',
            postion: 'bottom',
        },

        {
            name: 'Handsets',
            type: 'group',
            key: 'group_handsets_t',
            postion: 'top',
        },
        {
            name: 'Devices',
            icon: 'fa fa-mobile',
            path: '/devices/summary',
            key: 'device',
        },
        {
            name: 'Batteries',
            icon: 'fa fa-bolt',
            path: '/batteries/summary',
            key: 'battery',
        },
        // {
        //     name: 'Application Mgmt',
        //     icon: 'fa fa-mobile',
        //     path: '/application',
        //     key: 'application',
        // },
        {
            name: 'Handsets',
            type: 'group',
            key: 'group_handsets_b',
            postion: 'bottom',
        },
        // {
        //     name: 'Utilities',
        //     type: 'group',
        //     key: 'group_utilities_t',
        //     postion: 'top',
        // },
        // {
        //     name: 'Application Mgmt.',
        //     icon: 'fa fa-android',
        //     path: '/application',
        //     key: 'applicationmgmt',
        // },
        // {
        //     name: 'Sys Updater',
        //     icon: 'fa fa-cloud-download',
        //     path: '/sysupdater',
        //     key: 'sysupdater',
        // },
        // {
        //     name: 'Logging',
        //     icon: 'fa fa-file-text',
        //     path: '/logging',
        //     key: 'logging',
        // },

        // {
        //     name: 'Utilities',
        //     type: 'group',
        //     key: 'group_utilities_b',
        //     postion: 'bottom',
        // },

        {
            name: 'Infrastructure',
            type: 'group',
            key: 'group_infrastructure_t',
            postion: 'top',
        },
        {
            name: 'Infrastructure',
            type: 'group',
            key: 'group_infrastructure_b',
            postion: 'bottom',
        },
        {
            name: 'Hierarchy',
            type: 'group',
            key: 'group_hierarchy_t',
            postion: 'top',
        },
        {
            name: 'Accounts',
            icon: 'fa fa-user-o',
            path: '/accounts',
            key: 'accounts',
        },
        {
            name: 'Organizations',
            icon: 'fa fa-circle-o',
            path: '/organizations',
            key: 'organizations',
        },
        {
            name: 'Locations',
            icon: 'fa fa-map-marker',
            path: '/locations',
            key: 'locations',
        },
        {
            name: 'Hierarchy',
            type: 'group',
            key: 'group_hierarchy_b',
            postion: 'bottom',
        },
        {
            name: 'AMiE Settings',
            type: 'group',
            key: 'group_amie_settings_t',
            postion: 'top',
        },
        {
            name: 'Settings',
            icon: 'fa fa-cog',
            key: 'settings',
            path: '/settings',
            // children: [
            //     {
            //         name: "Account",
            //         path: "#",
            //         key: "settings.account",
            //     },
            //     {
            //         name: "Service Provider",
            //         path: "#",
            //         key: "settings.service-provider",
            //     },
            //     {
            //         name: "Data",
            //         path: "#",
            //         key: "settings.data",
            //     },
            //     {
            //         name: "Time",
            //         path: "#",
            //         key: "settings.time",
            //     },
            //     {
            //         name: "Server Reg.",
            //         path: "#",
            //         key: "settings.server-reg",
            //     }
            // ]
        },
        {
            name: 'Administration',
            icon: 'fa fa-gears',
            key: 'administration',
            children: [
                {
                    name: 'Licenses',
                    path: '/administration/licenses',
                    key: 'administration.license',
                },
                // {
                //     name: 'Locations',
                //     path: '/administration/location-summary',
                //     key: 'administration.locations',
                // },
                {
                    name: 'Users',
                    path: '/administration/users',
                    key: 'administration.admin-users',
                },
                // {
                //     name: 'Portal Authentication',
                //     path: '/administration/portal-authentication',
                //     key: 'administration.portal-authentication'
                // },
                // {
                //     name: "Permissions",
                //     path: "/administration/permissions",
                //     key: "administration.permissions",
                // },
                {
                    name: 'Timezone',
                    path: '/administration/timezone',
                    key: 'administration.timezone',
                },
            ],
        },
        {
            name: 'Spectralink Admin',
            icon: 'fa icon-sp',
            path: '/spectralink-admin/system-users',
            key: 'spectralink-admin',
        },
        {
            name: 'AMiE Settings',
            type: 'group',
            key: 'group_amie_settings_b',
            postion: 'bottom',
        },
    ],

    END_OF_24H_PERIOD: [
        {
            text: '7 PM',
            value: 19,
        },
        {
            text: '8 PM',
            value: 20,
        },
        {
            text: '9 PM',
            value: 21,
        },
        {
            text: '10 PM',
            value: 22,
        },
        {
            text: '11 PM',
            value: 23,
        },
        {
            text: '12 AM',
            value: 0,
        },
        {
            text: '1 AM',
            value: 1,
        },
        {
            text: '2 AM',
            value: 2,
        },
        {
            text: '3 AM',
            value: 3,
        },
        {
            text: '4 AM',
            value: 4,
        },
        {
            text: '5 AM',
            value: 5,
        },
        {
            text: '6 AM',
            value: 6,
        },
        {
            text: '7 AM',
            value: 7,
        },
    ],
};

export const settingsConstants = {
    AMIE_PAGE_DASHBOARD: 'AMiEPage_Dashboard',
    AMIE_PAGE_DETAILPAGES: 'AMiEPage_DetailPages',
    AMIE_PAGE_SUMMARYPAGES: 'AMiEPage_SummaryPages',
};

export const dateFormatConstants = {
    DATE: 'MMM DD YYYY',
    DATE_TIME: 'MMM DD HH:mm',
    TIME: 'HH:mm',

    YYYY_MM_DD: 'MMM DD YYYY',
    YYYY_MM_DD_TIME: 'MMM DD YYYY HH:mm',
    YYYY_MM_DD_TIME_SS: 'MMM DD YYYY HH:mm:ss',
};
export const AppConstants = {
    TITLE: 'AMiE',
    OPENT_PAGE_COUNT: 'OPENT_PAGE_COUNT',
    LAST_REQUERT_TIME: 'LAST_REQUERT_TIME',
    SET_APP_LANGUAGE: 'SET_APP_LANGUAGE',
    SET_APP_LANGUAGE_TEXTS: 'SET_APP_LANGUAGE_TEXTS',

    INIT_APP: 'INIT_APP',
    INIT_DATA: 'INIT_DATA',
    AUTH: 'AUTH!',
    TOKEN_EXP: 'token_exp',
    REFRESH_TOKEN: 'refresh_token',

    LOADING_START: 'LOADING_START',
    LOADING_END: 'LOADING_END',
    SET_TITLE: 'SET_TITLE',
    CURRENT_CUSTOMER: 'CURRENT_CUSTOMER',
    CURRENT_ORGANIZATION: 'CURRENT_ORGANIZATION',
    CURRENT_LOCATION: 'CURRENT_LOCATION',
    CURRENT_ACCOUNT: 'CURRENT_ACCOUNT',
    LOAD_CUSTOMERS: 'LOAD_CUSTOMERS',
    LOAD_SITES: 'LOAD_SITES',
    ADMIN_ACCOUNT: 'ADMIN_ACCOUNT',
    ADMIN_ORGANIZATION: 'ADMIN_ORGANIZATION',

    LOAD_GROUPS: 'LOAD_GROUPS',
    SET_CURRENT_ACTIVE_MENU: 'SET_CURRENT_ACTIVE_MENU',
    SET_CURRENT_PAGE_INFO: 'SET_CURRENT_PAGE_INFO',
    SET_MENUS: 'SET_MENUS',
    SET_NOTIFICATION_TIME_RANGE: 'SET_NOTIFICATION_TIME_RANGE',

    GET_SPECTRALINK_ADMIN: 'GET_SPECTRALINK_ADMIN',
    UPDATE_SPECTRALINK_BRANDING: 'UPDATE_SPECTRALINK_BRANDING',
    UPDATE_SPECTRALINK_GLOBAL_SETTING: 'UPDATE_SPECTRALINK_GLOBAL_SETTING',
    UPDATE_SPECTRALINK_EULA: 'UPDATE_SPECTRALINK_EULA',

    LOAD_ALERT_THRESHOLD_TABLE: 'LOAD_ALERT_THRESHOLD_TABLE',
    FS_URL_PREFIX: 'FS_URL_PREFIX',
    FS_URL_SIGNATURE: 'FS_URL_SIGNATURE'
};

export const AccountConstants = {
    SIGN_IN: 'SIGN_IN',
    LOGOUT: 'LOGOUT',
    UPDATE_CURRENT_AVATAR: 'UPDATE_CURRENT_AVATAR',
    GET_PERMISSIONS: 'GET_PERMISSIONS',
    GET_ACCOUNTS_TABLE_DATA: 'GET_ACCOUNTS_TABLE_DATA',
    UPDATE_ACCOUNT_BRANDING_DATA: 'UPDATE_ACCOUNT_BRANDING_DATA',
};
export const NotificationConstants = {
    LOAD_NOTIFICATION_TABLE: 'LOAD_NOTIFICATION_TABLE',
    GET_EMAIL_NOTIFICATION_DETAIL: 'GET_EMAIL_NOTIFICATION_DETAIL',
    GET_SMS_NOTIFICATION_DETAIL: 'GET_SMS_NOTIFICATION_DETAIL',
    daytermination90: '90 Days prior to termination',
    daytermination60: '60 Days prior to termination',
    daytermination30: '30 Days prior to termination',
};

export const roleConstants = {
    LOAD_ROLE_TABLE: 'LOAD_ROLE_TABLE',
    GET_ROLE_DETAIL: 'GET_ROLE_DETAIL',
};

export const deviceConstants = {
    LOAD_DEVICE_TABLE: 'LOAD_DEVICE_TABLE',
    LOAD_DEVICE_TOTAL: 'LOAD_DEVICE_TOTAL',
    GET_DEVICE_SUMMARY: 'GET_DEVICE_SUMMARY',
    GET_DEVICE_DETAIL: 'GET_DEVICE_DETAIL',
    CLEAR_DEVICE_DETAIL: 'CLEAR_DEVICE_DETAIL',
    GET_DEVICE_DETAIL_TAGS: 'GET_DEVICE_DETAIL_TAGS',
    GET_DEVICE_CHECK_IN_SUMMARY: 'GET_DEVICE_CHECK_IN_SUMMARY',
    GET_UTILIZATION_SUMMARY: 'GET_UTILIZATION_SUMMARY',

    SET_DEVICE_TABLE_FILTER: 'SET_DEVICE_TABLE_FILTER',
    LOAD_MESSAGE_TABLE: 'LOAD_MESSAGE_TABLE',
};
export const batteryConstants = {
    LOAD_BATTERY_TABLE: 'LOAD_BATTERY_TABLE',
    LOAD_BATTERY_TOTAL: 'LOAD_BATTERY_TOTAL',
    GET_BATTERY_DETAIL: 'GET_BATTERY_DETAIL',
    CLEAR_BATTERY_DETAIL: 'CLEAR_BATTERY_DETAIL',
    GET_BATTERIES_SUMMARY_DATA: 'GET_BATTERIES_SUMMARY_DATA',
    GET_TOP_APPS_SUMMARY_DATA: 'GET_TOP_APPS_SUMMARY_DATA',

    GET_BATTERIES_STATUS_SUMMARY: 'GET_BATTERIES_STATUS_SUMMARY',
    GET_BATTERIES_CHECK_IN_SUMMARY: 'GET_BATTERIES_CHECK_IN_SUMMARY',
};
export const locationConstants = {
    LOAD_REVIEW: 'LOAD_REVIEW',
    LOAD_LOCATION_TABLE: 'LOAD_LOCATION_TABLE',
    LOAD_FLOOR_TABLE: 'LOAD_FLOOR_TABLE',
    GET_LOCATION_DETAIL: 'GET_LOCATION_DETAIL',
    GET_LOCATION_CONTACTS: 'GET_LOCATION_CONTACTS',
    GET_LOCATION_FLOORS: 'GET_LOCATION_FLOORS',
    CREATE_SITE: 'CREATE_SITE',
    CLEAR_LOCATION_DETAIL: 'CLEAR_LOCATION_DETAIL',

    GET_LOCATION_DROPDOWN_LIST: 'GET_LOCATION_DROPDOWN_LIST',

    LOAD_LOCATION_SUMMARY_TABLE: 'LOAD_LOCATION_SUMMARY_TABLE',

    LOAD_LOCATION_SPARES_TABLE: 'LOAD_LOCATIONS_LOCATION_SPARES_TABLE',
    GET_ADMIN_GATEWAY_DETAIL: 'GET_ADMIN_GATEWAY_DETAIL',
};

export const organizationConstant = {
    LOAD_ORGANIZATION_TABLE: 'LOAD_ORGANIZATION_TABLE',
};

export const userConstants = {
    LOAD_USER_TABLE: 'LOAD_USER_TABLE',
};

export const basicConstants = {
    DATA_DICTIONARY: 'DATA_DICTIONARY',
    LOAD_DATA_DICTIONARY_TYPES: 'LOAD_DATA_DICTIONARY_TYPES',
};
export const commonConstants = {
    GET_COMMON_DEVICE_MODELS: 'GET_COMMON_DEVICE_MODELS',
    GET_COMMON_DEVICE_VERSITY_VERSIONS: 'GET_COMMON_DEVICE_VERSITY_VERSIONS',
    GET_COMMON_ALERT_STATUS: 'GET_COMMON_ALERT_STATUS',
    GET_COMMON_ALERT_TYPES: 'GET_COMMON_ALERT_TYPES',
    GET_COMMON_LOCATIONS: 'GET_COMMON_LOCATIONS',
    GET_ALERT_COUNT_BY_TENANT: 'GET_ALERT_COUNT_BY_TENANT',
    GET_ORGANIZATIONS: 'GET_COMMON_ORGANIZATIONS',
    GET_ROLE_OPTIONS: 'GET_ROLE_OPTIONS',
    GET_LOCATION_OPTIONS: 'GET_LOCATION_OPTIONS',
    GET_DEVICE_TAGS: 'GET_DEVICE_TAGS',
    GET_TIME_ZONE_OPTIONS: 'GET_TIME_ZONE_OPTIONS',
    GET_COUNTRY_OPTIONS: 'GET_COUNTRY_OPTIONS',
    GET_SUBDIVISION_OPTIONS: 'GET_SUBDIVISION_OPTIONS',

    GET_ACCOUNTS_OPTIONS: 'GET_ACCOUNTS_OPTIONS',
    GET_ACCOUNT_ORGANIZATIONS: 'GET_ACCOUNT_ORGANIZATIONS',
    GET_ORGANIZATION_OPTIONS: 'GET_ORGANIZATION_OPTIONS',
};

export const performanceConstants = {
    GET_PERFORMANCE_SUMMARY_DATA: 'GET_PERFORMANCE_SUMMARY_DATA',
    GET_PERFORMANCE_CALL_PERFORMANCE: 'GET_PERFORMANCE_CALL_PERFORMANCE',
    GET_CALL_PERFORMANCE_SUMMARY: 'GET_CALL_PERFORMANCE_SUMMARY',
    GET_CALL_PERFORMANCE_BY_AP: 'GET_CALL_PERFORMANCE_BY_AP',
    GET_CALL_PERFORMANCE_BY_DEVICE: 'GET_CALL_PERFORMANCE_BY_DEVICE',

    GET_DROPPED_CALLS_BY_AP: 'GET_DROPPED_CALLS_BY_AP',
    GET_DROPPED_CALLS_BY_DEVICE: 'GET_DROPPED_CALLS_BY_DEVICE',
    GET_DROPPED_CALLS_SUMMARY: 'GET_DROPPED_CALLS_SUMMARY',

    GET_LONG_HANDOFF_BY_AP: 'GET_LONG_HANDOFF_BY_AP',
    GET_LONG_HANDOFF_BY_DEVICE: 'GET_LONG_HANDOFF_BY_DEVICE',
    GET_LONG_HANDOFF_SUMMARY: 'GET_LONG_HANDOFF_SUMMARY',

    GET_PACKET_LOSS_BY_AP: 'GET_PACKET_LOSS_BY_AP',
    GET_PACKET_LOSS_BY_DEVICE: 'GET_PACKET_LOSS_BY_DEVICE',
    GET_PACKET_LOSS_SUMMARY: 'GET_PACKET_LOSS_SUMMARY',

    GET_LOW_SIGNAL_STRENG_BY_AP: 'GET_LOW_SIGNAL_STRENG_BY_AP',
    GET_LOW_SIGNAL_STRENG_BY_DEVICE: 'GET_LOW_SIGNAL_STRENG_BY_DEVICE',
    GET_LOW_SIGNAL_STRENG_SUMMARY: 'GET_LOW_SIGNAL_STRENG_SUMMARY',
};

export const chartConstants = {
    COLORS: [
        '#8A2BE2',
        '#DEB887',
        '#90a1bf',
        '#DC143C',
        '#008B8B',
        '#006400',
        '#E9967A',
        '#00CED1',
        '#FFD700',
        '#808080',
        '#F0E68C',
        '#800000',
    ],
    DEFAULT_DOUGHNUT_HEIGHT: 180,
};

export const alertConstants = {
    LOAD_ALERT_TABLE: 'LOAD_ALERT_TABLE',
    GET_ALERT_RULES: 'GET_ALERT_RULES',
    GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
    GET_RULE_OPERATIONS_DEFINITIONS: 'GET_RULE_OPERATIONS_DEFINITIONS',
    GET_CRITERIA_DEFINITIONS: 'GET_CRITERIA_DEFINITIONS',
    STATUS: [
        // 'Opened',
        'New',
        'Acknowledged',
        'In Progress',
        // 'Waiting for Verification',
        // 'Complete',
        'Closed',
        // 'Unspecified Alert Status',
    ],
    STATUS_OPTIONS: [
        {
            text: 'New',
            value: 'Opened',
        },
        {
            text: 'Acknowledged',
            value: 'Received',
        },
        {
            text: 'In Progress',
            value: 'In Progress',
        },
        {
            text: 'Closed',
            value: 'Closed',
        },
    ],
    SEVERITY: [
        'Critical',
        'Error',
        'Warning',
        'Information',
        'Debugging',
        'Unspecified Alert Severity',
    ],
    STATUS_COLORS: [
        'black',
        'black',
        'black',
        'black',
        'black',
        'black',
        'black',
        'black',
    ],
};

export const licensesConstants = {
    LOAD_LICENSES_TABLE: 'LOAD_LICENSES_TABLE',
    GET_LICENSE_SUMMARY: 'GET_LICENSE_SUMMARY',
};

export const serviceProviderConstants = {
    LOAD_SERVICE_PROVIDER_TABLE: 'LOAD_SERVICE_PROVIDER_TABLE',
};

export const onboardingConstants = {
    ONBOARDING_COMPLETE: 'ONBOARDING_COMPLETE',
    ONBOARDING_SET_SESSION_ID: 'ONBOARDING_SET_SESSION_ID',
    ONBOARDING_SET_TIMEZONES: 'ONBOARDING_SET_TIMEZONES',
};

export const retiredDevicesConstants = {
    LOAD_DEVICES_TABLE: 'LOAD_DEVICES_TABLE',
    DEVICETYPE: ['Active', 'Retired '],
};

export const configStatusConstants = {
    Not_Started: 'Not Started',
    Pending: 'Pending',
    Complete: 'Complete',
    Failed: 'Failed',
};
export const settingConstants = {
    LOAD_SETTING_TABLE: 'LOAD_SETTING_TABLE',
    MonthlyPDFReports: {
        Subject: 'MonthlyPDFReports_Subject',
        Message: 'MonthlyPDFReports_Message',
        Recipients: 'MonthlyPDFReports_Recipients',
    },
    AlertNotificationEmail: {
        Subject: 'AlertNotificationEmail_Subject',
        Message: 'AlertNotificationEmail_Message',
        Recipients: 'AlertNotificationEmail_Recipients',
    },
    AMiEPage: {
        Dashboard: 'AMiEPage_Dashboard',
        SummaryPages: 'AMiEPage_SummaryPages',
        DetailPages: 'AMiEPage_DetailPages',
    },
    SSIDS: 'Setting_SSIDS',
    BatteryReplacementMessages: {
        Message: 'BatteryReplacementMessages_Message',
        IsActive: 'BatteryReplacementMessages_IsActive',
        Percentage: 'BatteryReplacementMessages_MessagePercentage'
    },
};

export const administrationConstants = {
    SET_ACTIVE_DEVICES_LOCATION: 'SET_ACTIVE_DEVICES_LOCATION',
    SET_LOCATION_SPARES_LOCATION: 'SET_LOCATION_SPARES_LOCATION',
};

export const adminUserConstants = {
    LOAD_ADMIN_USER_TABLE: 'LOAD_ADMIN_USER_TABLE',
};

export const permissionConstants = {
    //--dashboard
    DASHBOARD: 'dashboard',

    //--alert
    ALERT: 'alert',
    ALERTS_LISTING: 'alert.listing',
    ALERTS_EXPORT: 'alert.listing.export',
    ALERTS_UPDATE: 'alert.listing.update',

    LOCATION_VIEW: 'location_view',

    //-- deivce
    DEVICE: 'device',
    DEVICES_SUMMARY: 'device.summary',

    DEVICES_LISTING: 'device.listing',
    DEVICES_LISTING_EXPORT: 'device.listing.export',

    DEVICES_DETAIL: 'device.detail',
    DEVICES_DETAIL_SEND_MESSAGE: 'device.detail.send-message',
    DEVICES_DETAIL_REACTIVE: 'device.detail.reactive',
    DEVICES_DETAIL_RETIRE_DEVICE: 'device.detail.retire-device',

    //--battery
    BATTERY: 'battery',
    BATTERIES_SUMMARY: 'battery.summary',

    BATTERIES_LISTING: 'battery.listing',
    BATTERIES_LISTING_EXPORT: 'battery.listing.export',

    BATTERIES_DETAIL: 'battery.detail',
    BATTERIES_DETAIL_SEND_MESSAGE: 'battery.detail.send-message',
    BATTERIES_DETAIL_REACTIVE: 'battery.detail.reactive',
    BATTERIES_DETAIL_RETIRE: 'battery.detail.retire',

    //--Performance
    APPLICATION: 'application',
    APPLICATION_APPLICATIONS: 'application.applications',
    APPLICATION_GROUPS: 'application.groups',
    APPLICATION_COPY_CONFIGURATION: 'application.copy_configuration',
    APPLICATION_CONFIGURATION_BACKUP: 'application.configuration_backup',
    APPLICATION_REGISTRATION_INFO: 'application.registration_info',
    APPLICATION_OPTION: 'application.option',

    UTILITIES_APPLICATION: 'applicationmgmt',
    UTILITIES_APPLICATION_DETAIL: 'applicationmgmt.detail',
    UTILITIES_SYSUPDATER: 'sysupdater',
    UTILITIES_SYSUPDATER_DETAIL: 'sysupdater.detail',
    UTILITIES_LOGGING: 'logging',
    UTILITIES_LOGGING_DETAIL: 'logging.detail',

    //--Performance
    PERFORMANCE: 'performance',
    PERFORMANCE_CALL_PERFORMANCE_SUMMARY:
        'performance.call-performance-summary',
    PERFORMANCE_CALL_PERFORMANCE_SUMMARY_EXPORT:
        'performance.call-performance-summary.export',

    PERFORMANCE_DROPPED_CALL_SUMMARY: 'performance.dropped-call-summary',
    PERFORMANCE_DROPPED_CALL_SUMMARY_EXPORT:
        'performance.dropped-call-summary.export',

    PERFORMANCE_LONG_HANDOFF_SUMMARY: 'performance.long-handoff-summary',
    PERFORMANCE_LONG_HANDOFF_SUMMARY_EXPORT:
        'performance.long-handoff-summary.export',

    PERFORMANCE_LOW_RSSI_EVENTS_SUMMARY: 'performance.low-rssi-events-summary',
    PERFORMANCE_LOW_RSSI_EVENTS_SUMMARY_EXPORT:
        'performance.low-rssi-events-summary.export',

    PERFORMANCE_PACKET_SUMMARY: 'performance.packet-summary',
    PERFORMANCE_PACKET_SUMMARY_EXPORT: 'performance.packet-summary.export',

    //--organization
    ORGANIZATIONS: 'organizations',
    ORGANIZATIONS_ADD: 'organizations.add',
    ORGANIZATIONS_LISTING: 'organizations.listing',
    ORGANIZATIONS_LISTING_EXPORT: 'organizations.listing.export',

    //--location
    LOCATIONS: 'locations',
    LOCATIONS_LISTING: 'locations.listing',
    LOCATIONS_LISTING_EXPORT: 'locations.listing.export',
    LOCATIONS_DELETE: 'locations.delete',
    LOCATIONS_ADD: 'locations.add',

    LOCATIONS_DETAIL: 'locations.detail',
    LOCATIONS_DETAIL_EDIT: 'locations.detail.edit',
    LOCATIONS_DETAIL_UPLOAD_AP_LIST: 'locations.upload-ap-list',
    LOCATIONS_DETAIL_EDIT_LOCATION_CONTACTS: 'locations.edit-location-contacts',

    LOCATIONS_FLOOR: 'locations.floor',
    LOCATIONS_FLOOR_ADD: 'locations.add-floors',
    LOCATIONS_FLOOR_DELETE: 'locations.floors.delete',
    LOCATIONS_FLOOR_ASSIGN_AP: 'locations.assign-ap',
    LOCATIONS_FLOOR_EDIT_FLOOR_INFO: 'locations.edit-floor-info',
    LOCATIONS_FLOOR_UPLOAD_FLOOR_PLAN: 'locations.upload-floor-plan',

    LOCATIONS_FLOOR_EDIT_AP: 'locations.floor.edit-ap',
    LOCATIONS_FLOOR_DELETE_AP: 'locations.floor.delete-ap',

    //--setting
    SETTINGS: 'settings',
    SETTINGS_EDIT_ALERT_NOTIFICATION_EMAIL:
        'settings.edit-alert-notification-email',
    SETTINGS_EDIT_MONTHLY_PDF_REPORTS_EMAIL:
        'settings.edit-monthly-pdf-reports-email',
    SETTINGS_EDIT_PAGE_REFRESH_FREQUENCY:
        'settings.edit-page-refresh-frequency',

    //--admin

    ADMINISTRATION_ADMIN_USERS: 'administration.admin-users',
    ADMINISTRATION_LICENSE: 'administration.license',
    ADMINISTRATION_LOCATIONS: 'administration.locations',
    ADMINISTRATION_PORTAL_AUTHENTICATION:
        'administration.portal-authentication',
    ADMINISTRATION_PERMISSIONS: 'administration.permissions',
    ADMINISTRATION_TIMEZONE: 'administration.timezone',
    ADMINISTRATION_ALERTS: 'administration.alerts',
    //admin admin user
    ADMINISTRATION_SYSTEM_USERS: 'administration.system-users',
    ADMINISTRATION_SYSTEM_USERS_ADD: 'administration.system-users.add',
    ADMINISTRATION_SYSTEM_USERS_EXPORT: 'administration.system-users.export',
    ADMINISTRATION_SYSTEM_USERS_DELETE: 'administration.system-users.delete',

    //admin locations
    ADMINISTRATION_LOCATIONS_SUMMARY:
        'administration.locations.location-summary',
    ADMINISTRATION_GATEWAY_SUMMARY: 'administration.locations.gateway-summary',
    ADMINISTRATION_LOCATIONS_SUMMARY_ADD_LOCATION:
        'administration.locations.location-summary.add-location',
    //admin license
    ADMINISTRATION_LOCATIONS_ADD_LICENSE: 'administration.license.add-license',
    ADMINISTRATION_LOCATIONS_MANAGE_NOTIFICATIONS:
        'administration.license.manage-notifications',
    ADMINISTRATION_LOCATIONS_DELETE_LICENSE: 'administration.license.delete-license',
    //admin device battery

    //--Spectralink_Admin
    SPECTRALINK_ADMIN: 'spectralink-admin',
    SPECTRALINK_ADMIN_OVERVIEW: 'spectralink-admin.overview',
    SPECTRALINK_ADMIN_GLOBAL_SETTINGS: 'spectralink-admin.global-settings',
    SPECTRALINK_ADMIN_GLOBAL_SETTINGS_EDIT:
        'spectralink_admin.global_settings.edit',

    SPECTRALINK_ADMIN_SYSTEM_USERS: 'spectralink-admin.system-users',
    SPECTRALINK_ADMIN_SYSTEM_USERS_DELETE:
        'spectralink-admin.system-users.delete',
    SPECTRALINK_ADMIN_SYSTEM_USERS_EXPORT:
        'spectralink-admin.system-users.export',
    SPECTRALINK_ADMIN_SYSTEM_USERS_ADD: 'spectralink-admin.system-users.add',

    SPECTRALINK_ADMIN_SYSTEM_ROLES: 'spectralink-admin.system-roles',
    SPECTRALINK_ADMIN_SYSTEM_ROLES_ADD: 'spectralink-admin.system-roles.add',
    SPECTRALINK_ADMIN_SYSTEM_ROLES_DELETE:
        'spectralink-admin.system-roles.delete',


    SPECTRALINK_ADMIN_ALERTS: 'spectralink-admin.alerts',
    SPECTRALINK_ADMIN_ALERTS_EDIT: 'spectralink-admin.alerts.edit',
    SPECTRALINK_ADMIN_ALERTS_DELETE: 'spectralink-admin.alerts.delete',
    SPECTRALINK_ADMIN_ALERTS_ADD: 'spectralink-admin.alerts.add',
    SPECTRALINK_ADMIN_ALERTS_RULEDEFINITIONS:
        'spectralink-admin.alerts.rule_definitions',
    SPECTRALINK_ADMIN_ALERTS_ADDALERTCRITERIA:
        'spectralink-admin.alerts.alertcriteria',
    SPECTRALINK_ADMIN_LANGUAGE: 'spectralink-admin.language',
    SPECTRALINK_ADMIN_LANGUAGE_UPLOAD: 'spectralink-admin.language.upload',
    SPECTRALINK_ADMIN_LANGUAGE_ADD: 'spectralink-admin.language.add',
    SPECTRALINK_ADMIN_LANGUAGE_EDIT: 'spectralink-admin.language.edit',
    SPECTRALINK_ADMIN_LANGUAGE_DELETE: 'spectralink-admin.language.delete',


};

export const roleTypeConstants = {
    SPECTRALINK_USER: 'SpectralinkUser',
    SERVICE_PROVIDER: 'ServiceProvider',
    ACCOUNT_USER: 'AccountUser',
};

export const alertThresholdTriggers = [
    'low_call_quality_fleet',
    'low_call_quality_ap',
    'low_call_quality_device',
    'battery_degradation_warning',
    'battery_replacement_warning',
    'device_out_of_contact_warning',
    'gateway_out_of_contact_warning',
    'storage_warning',
    'overutilization_warning',
];

export const notificationType = {
    EMAIL: 'EMAIL',
    SMS: 'SMS',
};

export const moreColors = [
    'rgba(41,79,136,0.6)',
    '#00FFFF',
    '#7FFFD4',
    '#F5F5DC',
    '#FFE4C4',
    '#87CEFA',
    '#DEB887',
    '#5F9EA0',
    '#7FFF00',
    '#D2691E',
    '#FF7F50',
    '#6495ED',
    '#FFF8DC',
    '#DC143C',
    '#00FFFF',
    '#00008B',
    '#008B8B',
    '#66CDAA',
    '#006400',
    '#FF8C00',
    '#8FBC8F',
    '#483D8B',
    '#696969',
    '#F8F8FF',
    '#FFD700',
    '#ADFF2F',
    '#D3D3D3',
];

export const languageCode = {
    EN: 'en-US',
    DE: 'de-DE',
    ES: 'es-ES',
    FR: 'fr-FR',
};

export const performanceOptions = [
    {
        text: 'Call Performance',
        value: 'Call Performance',
    },
    {
        text: 'Long Handoffs',
        value: 'Long Handoffs',
    },
    {
        text: 'Low RSSI',
        value: 'Low RSSI',
    },
    {
        text: 'Dropped Packets',
        value: 'Dropped Packets',
    },
    {
        text: 'Missed Packets',
        value: 'Missed Packets',
    },
];
// export const baseColors = {
//     green: 'darkgreen',
//     yellow: 'rgb(240, 173, 78)',
//     red: 'rgb(174, 0, 0)',
// };

export const baseColors = {
    green: '#008000',
    yellow: '#e3ad00',
    red: '#ca0c1c',
    gray: 'rgba(0, 0, 0, 0.65)',
    blue: 'rgb(54, 162, 235)',
    orange: 'rgb(255, 165, 0)',
    gold: '#FFD700',
};

export const roleNameConstant = {
    Spectralink_Super_User: 'Spectralink Super User',
    Account_Super_User: 'Account Super User',
    Service_Provider_Super_User: 'Service Provider Super User',
};

export const timeRanges = [
    { text: '<24h', value: '<24h' },
    { text: '1-2d', value: '1-2d' },
    { text: '2-3d', value: '2-3d' },
    { text: '3-7d', value: '3-7d' },
    { text: '>7d', value: '>7d' },
];
export const languages = [
    {
        text: 'English',
        value: 'en-US',
        icon: 'famfamfam-flags gb',
    },
    {
        text: 'French',
        value: 'fr-FR',
        icon: 'famfamfam-flags fr',
    },
    {
        text: 'German',
        value: 'de-DE',
        icon: 'famfamfam-flags de',
    },
    {
        text: 'Spanish',
        value: 'es-ES',
        icon: 'famfamfam-flags es',
    },
    {
        text: 'Italian',
        value: 'it-IT',
        icon: 'famfamfam-flags it',
    },
    {
        text: 'Dutch',
        value: 'nl-NL',
        icon: 'famfamfam-flags nl',
    },
];